import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import Link from 'components/Link';
import Account from 'modules/Account';
import CloudDrive from 'modules/CloudDrive';
import Patient from 'modules/Patient';
import { DownloadDataFromMeterBtn } from 'modules/Meter';
import TopBar from '../../../partials/TopBar';
import ActivePatientOptions from '../TopBar/ActivePatientOptions';
import ProfileMenu from '../TopBar/ProfileMenu';
import Notifications from '../TopBar/Notifications';
import styles from '../TopBar/TopBar.pcss';
const DownloadMeter = ({ isReadOnly })=>{
    const activeProfileType = useSelector(Account.selectors.activeProfileType);
    const isSyncInProgress = useSelector(Patient.selectors.isSyncInProgress);
    const isFetchPhiSetInProgress = useSelector(CloudDrive.selectors.isFetchPhiSetInProgress);
    const isFetchReadingsInProgress = useSelector(CloudDrive.selectors.isFetchReadingsInProgress);
    const isDisabled = isFetchPhiSetInProgress || isFetchReadingsInProgress || isSyncInProgress;
    if (activeProfileType === Account.constants.PROFILE_TYPES.CG) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.element,
        children: /*#__PURE__*/ _jsx(DownloadDataFromMeterBtn, {
            className: "btn--block btn--filled",
            isReadOnly: isReadOnly,
            isDisabled: isDisabled
        })
    });
};
const PwdTopBar = ({ isReadOnly })=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsxs(TopBar, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.element,
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "/",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/assets/img/gco-logo.png",
                                className: styles.logo,
                                alt: "GlucoContro.online"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(DownloadMeter, {
                        isReadOnly: isReadOnly
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.element, 'd-flex align-items-center'),
                children: [
                    /*#__PURE__*/ _jsx(ActivePatientOptions, {}),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.separate)
                    }),
                    /*#__PURE__*/ _jsx(Notifications, {}),
                    /*#__PURE__*/ _jsx(ProfileMenu, {})
                ]
            })
        ]
    });
};
export default PwdTopBar;
